export const TOOLTIP_DESCRIPTION = `Expenditures made to a supplier of goods for the supply of goods that are essential
    to your operations at the time at which the expenditure was made, and pursuant to a contract, order, or purchase order in effect
    prior to the beginning of the Covered Period. For perishable goods, the contract, order or purchase may have been in effect before or
    at any time during the Covered Period.`;

export const TOOLTIP_NAME = 'coveredSupplierCostsTooltip';
